import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { to: "/", label: "首页" },
    { to: "/category/all", label: "全部评测" },
    { to: "/category/hot-blooded", label: "热血战斗" },
    { to: "/category/fantasy", label: "奇幻冒险" },
    { to: "/category/comedy", label: "日常喜剧" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-foreground-900">
                {t("site.name")}
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t("footer.slogan")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 font-heading">
              {t("footer.links")}
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 font-heading">
              {t("footer.followUs")}
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                >
                  <i className="ri-wechat-line"></i>
                  微信公众号
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                >
                  <i className="ri-bilibili-line"></i>
                  Bilibili
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                >
                  <i className="ri-weibo-line"></i>
                  微博
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                >
                  <i className="ri-tiktok-line"></i>
                  抖音
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4 font-heading">
              {t("footer.contact")}
            </h4>
            <ul className="space-y-2">
              <li className="text-sm text-foreground-600 flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@haohuai.me
              </li>
              <li className="text-sm text-foreground-600 flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                北京市朝阳区
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="container-site py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}